import { observer } from 'mobx-react';
import { sortDirection, valueFor } from '../../../../ListFilter';
import { SearchParameters } from '../../../../ListFilter/Types';
import { T } from '../../../../Translations';
import SortableColumn from '../../../SortableColumn';
import { SortableColumn as SortableColumnT } from '../GroupParticipantsStore/Types';

interface Props {
  searchParameters: SearchParameters;
  sorting: (sortedColumn: SortableColumnT) => void;
}

function Head({ searchParameters, sorting }: Props) {
  return (
    <thead className="bg-gray-50">
      <tr>
        <SortableColumn
          columnName={'Full Name'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('last_name')}
          sortKey="last_name"
          className="hidden py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:table-cell"
        />
        <SortableColumn
          columnName={'Email'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('email')}
          sortKey="email"
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        />
        <SortableColumn
          columnName={'Preferred Language'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('preferred_language')}
          sortKey="preferred_language"
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
        />
        <SortableColumn
          columnName={'Login Count'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('sign_in_count')}
          sortKey="sign_in_count"
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
        />
        <SortableColumn
          columnName={'Last Login'}
          currentSortKey={valueFor('sort_by', searchParameters)}
          sortDirection={sortDirection(searchParameters)}
          onSortClicked={() => sorting('last_sign_in_at')}
          sortKey="last_sign_in_at"
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell"
        />
        <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
          <T kind="Groups" />
        </th>
        <th
          colSpan={2}
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
        >
          <T kind="Collections" />
        </th>
      </tr>
    </thead>
  );
}

export default observer(Head);
